/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {BulkUserCrmId} from '../models/BulkUserCrmId';
import type {Error} from '../models/Error';
import type {UsersCrmIdUpdateResponse} from '../models/UsersCrmIdUpdateResponse';

export interface GetCrmUpdateBulkResult$Request {
    id: string;
}

export interface GetCrmUpdateBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCrmUpdateBulkResultRequest = createAction<PayloadData<void, GetCrmUpdateBulkResult$Request>>('BULK_CRM_UPDATE__GET_CRM_UPDATE_BULK_RESULT__REQUEST');
export const getCrmUpdateBulkResultSuccess = createAction<PayloadData<UsersCrmIdUpdateResponse, GetCrmUpdateBulkResult$Request>>('BULK_CRM_UPDATE__GET_CRM_UPDATE_BULK_RESULT__SUCCESS');
export const getCrmUpdateBulkResultFailure = createAction<PayloadData<Error, GetCrmUpdateBulkResult$Request, true>>('BULK_CRM_UPDATE__GET_CRM_UPDATE_BULK_RESULT__FAILURE');

export const getCrmUpdateBulkResultActions = [
    getCrmUpdateBulkResultRequest,
    getCrmUpdateBulkResultSuccess,
    getCrmUpdateBulkResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCrmUpdateBulkResult = (meta: GetCrmUpdateBulkResult$Request, config?: GetCrmUpdateBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getCrmUpdateBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/crm-ids`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserCrmUpdateProgress$Request {
    id: string;
}

export interface GetUserCrmUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserCrmUpdateProgressRequest = createAction<PayloadData<void, GetUserCrmUpdateProgress$Request>>('BULK_CRM_UPDATE__GET_USER_CRM_UPDATE_PROGRESS__REQUEST');
export const getUserCrmUpdateProgressSuccess = createAction<PayloadData<BulkProgress, GetUserCrmUpdateProgress$Request>>('BULK_CRM_UPDATE__GET_USER_CRM_UPDATE_PROGRESS__SUCCESS');
export const getUserCrmUpdateProgressFailure = createAction<PayloadData<Error, GetUserCrmUpdateProgress$Request, true>>('BULK_CRM_UPDATE__GET_USER_CRM_UPDATE_PROGRESS__FAILURE');

export const getUserCrmUpdateProgressActions = [
    getUserCrmUpdateProgressRequest,
    getUserCrmUpdateProgressSuccess,
    getUserCrmUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserCrmUpdateProgress = (meta: GetUserCrmUpdateProgress$Request, config?: GetUserCrmUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUserCrmUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/crm-ids/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUserCrmBulkUpdate$Request {
    id: string;
}

export interface StopUserCrmBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUserCrmBulkUpdateRequest = createAction<PayloadData<void, StopUserCrmBulkUpdate$Request>>('BULK_CRM_UPDATE__STOP_USER_CRM_BULK_UPDATE__REQUEST');
export const stopUserCrmBulkUpdateSuccess = createAction<PayloadData<void, StopUserCrmBulkUpdate$Request>>('BULK_CRM_UPDATE__STOP_USER_CRM_BULK_UPDATE__SUCCESS');
export const stopUserCrmBulkUpdateFailure = createAction<PayloadData<Error, StopUserCrmBulkUpdate$Request, true>>('BULK_CRM_UPDATE__STOP_USER_CRM_BULK_UPDATE__FAILURE');

export const stopUserCrmBulkUpdateActions = [
    stopUserCrmBulkUpdateRequest,
    stopUserCrmBulkUpdateSuccess,
    stopUserCrmBulkUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUserCrmBulkUpdate = (meta: StopUserCrmBulkUpdate$Request, config?: StopUserCrmBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUserCrmBulkUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/crm-ids`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateUsersCrmIds$Request {
    bulkUserCrmId: Array<BulkUserCrmId>;
    reason?: string;
}

export interface UpdateUsersCrmIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUsersCrmIdsRequest = createAction<PayloadData<void, UpdateUsersCrmIds$Request>>('BULK_CRM_UPDATE__UPDATE_USERS_CRM_IDS__REQUEST');
export const updateUsersCrmIdsSuccess = createAction<PayloadData<string, UpdateUsersCrmIds$Request>>('BULK_CRM_UPDATE__UPDATE_USERS_CRM_IDS__SUCCESS');
export const updateUsersCrmIdsFailure = createAction<PayloadData<Error, UpdateUsersCrmIds$Request, true>>('BULK_CRM_UPDATE__UPDATE_USERS_CRM_IDS__FAILURE');

export const updateUsersCrmIdsActions = [
    updateUsersCrmIdsRequest,
    updateUsersCrmIdsSuccess,
    updateUsersCrmIdsFailure
] as const;

/**
 * @param {Array<BulkUserCrmId>} meta.bulkUserCrmId
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUsersCrmIds = (meta: UpdateUsersCrmIds$Request, config?: UpdateUsersCrmIds$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updateUsersCrmIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/crm-ids`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.bulkUserCrmId,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

